export default __webpack_public_path__ + "static/media/block_blue.dbbf6060.svg";